package org.example.project.screens_driver

import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.encodeToString
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.utils.All

internal enum class DriverOrderLoadMode(val apiAction: String) {
    OPEN("open"),
    FINAL("final")
}

internal object DriverAuftraegeApi {
    @Serializable
    private data class CurrentOrderRequest(
        val providerFirmenId: String,
        val artCode: String,
        val auftragId: String,
        val lieferscheinnummer: String
    )

    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun load(mode: DriverOrderLoadMode): List<All> {
        val raw = LumaticaApiManager.call("driverauftraege/${mode.apiAction}")
        if (raw.isBlank() || raw == "null") return emptyList()
        return runCatching {
            json.decodeFromString(ListSerializer(All.AllNames.serializer()), raw)
        }.getOrDefault(emptyList())
    }

    suspend fun loadCurrent(
        providerFirmenId: String,
        artCode: String,
        auftragId: String,
        lieferscheinnummer: String
    ): All? {
        val body = json.encodeToString(
            CurrentOrderRequest(providerFirmenId, artCode, auftragId, lieferscheinnummer)
        )
        val raw = LumaticaApiManager.postJson("driverauftraege/current", body)
        if (raw.isBlank() || raw == "null") return null
        return runCatching { json.decodeFromString(All.AllNames.serializer(), raw) }.getOrNull()
    }
}
